import isVideoCallDisabledByReed from './isVideoCallDisabledByReed';

const rules = [
  isVideoCallDisabledByReed,
];

const isPersonalVideoCallDisabled = () => rules.some((rule) => rule());

export default isPersonalVideoCallDisabled;
